import React from "react";
import API from "@unisearch/helpers/api";

import { LayoutMain } from "@unisearch/theme/layout";
import TeamHero from "@modules/study/team/landing/hero";
import TeamMembersSection from "@modules/study/team/landing/section_members";
import BreadCrumbs from "@modules/study/team/components/breadcrumbs";
const baseUrl = process.env.NEXT_PUBLIC_URL;

const description =
  "<p>The talented individuals making up our team are at the core of what we do here at UniSearch. Our diverse team members use their international student recruitment expertise, insight, and experience in various emerging markets to find the right solution for each student and university partner.</p><p>We are proud to be represented by a group of passionate, creative, and dedicated individuals committed to the cause of making study abroad solutions simpler than ever.</p>";

const breadCrumbsData = [
  {
    id: 1,
    title: "Home",
    isActive: false,
    url: "/",
    isLink: true,
  },
  {
    id: 2,
    title: "Team",
    isActive: true,
    url: "",
    isLink: false,
  },
];

const TeamPage = ({ teamList }) => {
  return (
    <LayoutMain
      title="Team"
      metaUrl={`${baseUrl}/team`}
      metaTitle="Our talented team members"
      metaImage="/assets/metaimages/team-meta.png"
      metaDescription="The talented individuals making up our team are at the core of what we do here at UniSearch. Our diverse team members use their international student recruitment expertise, insight, and experience in various emerging markets to find the right solution for each student and university partner. We are proud to be represented by a group of passionate, creative, and dedicated individuals committed to the cause of making study abroad solutions simpler than ever."
      metaKeywords="team, unisearch team, talented team, team members, international team"
    >
      <TeamHero
        title="<span class='mark'>Our Team</span>"
        description={description}
        breadcrumbs={<BreadCrumbs data={breadCrumbsData} />}
      />

      {teamList && teamList?.length > 0 && (
        <TeamMembersSection data={teamList} />
      )}
    </LayoutMain>
  );
};

export default TeamPage;

export async function getServerSideProps() {
  let props = {
    teamList: [],
  };

  try {
    await API.get(`/public/team?limit=120000`).then((resp) => {
      if (!resp.error && resp.data) {
        props.teamList = resp.data;
      } else {
        return {
          redirect: {
            permanent: false,
            destination: "/404",
          },
        };
      }
    });
    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
